import React from "react";

const PackageUpdateForm = ({
  selection,
  setSelection,
  handleSubmit,
}) => {
  const handleOptionChange = (e) => {
    setSelection(e.target.value);
  };

  return (
    <div>
      <h3 className="text-center mb-4">¿Aceptas actualizar tu membresía?</h3>
      <p>Elige una opción para continuar:</p>
      <div className="mb-4">
        <div className="form-check mb-3 p-3 border rounded">
          <input
            className="form-check-input"
            type="radio"
            name="packageUpdate"
            id="accept"
            value="yes"
            checked={selection === "yes"}
            onChange={handleOptionChange}
          />
          <label className="form-check-label" htmlFor="accept">
            <span className="d-block mb-2">
              <strong>✅ Si acepto:</strong>
            </span>
            <span className="text-muted">
              tu membresía se actualiza automáticamente con el nuevo paquete, precio y vigencia a partir del 28/01/2026.
            </span>
          </label>
        </div>
        <div className="form-check mb-3 p-3 border rounded">
          <input
            className="form-check-input"
            type="radio"
            name="packageUpdate"
            id="decline"
            value="no"
            checked={selection === "no"}
            onChange={handleOptionChange}
          />
          <label className="form-check-label" htmlFor="decline">
            <span className="d-block mb-2">
              <strong>🧡 No acepto:</strong>
            </span>
            <span className="text-muted">
              tu membresía se detendrá al final de tu ciclo actual, y podrás elegir el paquete que mejor se adapte a ti cuando quieras.
            </span>
          </label>
        </div>
      </div>
      <button
        disabled={!selection}
        className="btn btn-primary w-100 btn-lg mb-3"
        onClick={handleSubmit}
      >
        Confirmar
      </button>
    </div>
  );
};

export default PackageUpdateForm;
